<div class="modal-body text-center">
    <p>{{ 'Please confirm that you want to send this reply to these customers:' | translate }}</p>
    <div class="mail-grid">
        @if (toUsers.length) {
            <div>{{ 'To:' | translate }}</div>
            <div>{{ toUsers | join }}</div>
        }
        @if (ccUsers.length) {
            <div>{{ 'Cc:' | translate }}</div>
            <div>{{ ccUsers | join }}</div>
        }
        @if (bccUsers.length) {
            <div>{{ 'Bcc:' | translate }}</div>
            <div>{{ bccUsers | join }}</div>
        }
    </div>
    <button type="button" class="btn btn-default mt-3" (click)="decline()">
        {{ 'No, let me revise my reply first' | translate }}
    </button>
    <button type="button" class="btn btn-primary mt-3 ms-2" (click)="confirm()">
        {{ 'Yes, send my reply now' | translate }}
    </button>
</div>
